import styled from '@emotion/styled';
import { Input as AntInput } from 'antd';

export const Input = styled(AntInput)<{ width?: string; height?: string }>`
  color: #4d4d4d;
  background-color: #ffffffb3;
  border-radius: ${({ height }) => (height ? height : undefined)};
  width: ${({ width }) => (width ? width : undefined)};
  height: ${({ height }) => (height ? height : undefined)};
`;
